module.exports = __webpack_public_path__ + "media/bgm.22909355.mp3";